import script from "./CommentsCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommentsCard.vue?vue&type=script&lang=ts&setup=true"

import "./CommentsCard.vue?vue&type=style&index=0&id=4ecc121b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ecc121b"]])

export default __exports__